var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#df8d6b",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 13H9l1.8-2.4a1 1 0 1 0-1.6-1.2l-3 4A1 1 0 0 0 7 15h18a1 1 0 0 0 0-2zM21.4 22.8a1 1 0 0 0 .6.2 1 1 0 0 0 .8-.4l3-4A1 1 0 0 0 25 17H7a1 1 0 0 0 0 2h16l-1.8 2.4a1 1 0 0 0 .2 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.19 3H24a1 1 0 0 0 0 2h2.19A1.81 1.81 0 0 1 28 6.81v18.38A1.81 1.81 0 0 1 26.19 27H5.81A1.81 1.81 0 0 1 4 25.19V6.81A1.81 1.81 0 0 1 5.81 5H20a1 1 0 0 0 0-2H5.81A3.82 3.82 0 0 0 2 6.81v18.38A3.82 3.82 0 0 0 5.81 29h20.38A3.82 3.82 0 0 0 30 25.19V6.81A3.82 3.82 0 0 0 26.19 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDld);
export default __webpack_public_path__ + "static/media/dld.5feb54b182fb8332b41b37dd021294f2.svg";
export { ForwardRef as ReactComponent };